'use strict';

import {
    getAttr
} from "./options";
import {
    escapeHtml
} from "./Utils";

function createRoom(room, itemsobj) {
    const user = getAttr("user");
    const groupid = getAttr("openGid");

    const hasRaumBild = (room.raumbild || (room.raumbild).length);
    const hasRaumBild2 = (room.raumbild2 || (room.raumbild2).length);
    const hasRaumBild3 = (room.raumbild3 || (room.raumbild3).length);
    const hasRaumBild4 = (room.raumbild4 || (room.raumbild4).length);
    const hasRaumKommentar = (room.raumkommentar || (room.raumkommentar).length);

    let roomDetail = ""
    let roomHeaderClassClickable = "";
    if (hasRaumBild || hasRaumBild2 || hasRaumBild3 || hasRaumBild4 || hasRaumKommentar) {
        roomHeaderClassClickable = "room-header-det";

        // todo
        // room-header-detail 
        // room-header-detail  => same as room-item
        roomDetail = `<div class="room-item-body ">`;
        if (hasRaumKommentar) {
            roomDetail += `<span class="room-body-header raumdetail"><strong>${escapeHtml(room.raumkommentar)}</strong></span>`;
        }

        if (hasRaumBild) {
            roomDetail += `<div class="room-body-imgs">`;
            roomDetail += `<img class="room-img" src="/data/img/${user.oid}/${groupid}/thumbnail/${escapeHtml(room.raumbild)}">`;
            roomDetail += `</div>`;
        }
        if (hasRaumBild2) {
            roomDetail += `<div class="room-body-imgs">`;
            roomDetail += `<img class="room-img" src="/data/img/${user.oid}/${groupid}/thumbnail/${escapeHtml(room.raumbild2)}">`;
            roomDetail += `</div>`;
        }
        if (hasRaumBild3) {
            roomDetail += `<div class="room-body-imgs">`;
            roomDetail += `<img class="room-img" src="/data/img/${user.oid}/${groupid}/thumbnail/${escapeHtml(room.raumbild3)}">`;
            roomDetail += `</div>`;
        }
        if (hasRaumBild4) {
            roomDetail += `<div class="room-body-imgs">`;
            roomDetail += `<img class="room-img" src="/data/img/${user.oid}/${groupid}/thumbnail/${escapeHtml(room.raumbild4)}">`;
            roomDetail += `</div>`;
        }
        roomDetail += `</div>`;
    }

    // console.log(room.raumbild, "  -  ", room.raumkommentar);

    const roomname = escapeHtml(room.raumname);

    var roomstr = `<div class="room" id="room_${room.rid}" ` +
        ` data-rid="${room.rid}">` +
        ` <div class="room-header">` +
        ` <div class="room-header-elem ${roomHeaderClassClickable} ">` +
        ` <span>${roomname}</span>`;


    if (user.admin == 1) {
        roomstr += `<div><i class="edit-room"></i><i class="add-entry"></i></div>`;
    }
    roomstr += `</div>`
    roomstr += roomDetail;
    roomstr += `</div>`
    // add room-detail if available


    roomstr += `<div class="room-body">`;
    itemsobj.forEach(function (dataElem) {
        roomstr += createDataRowElem(dataElem);
    });

    roomstr += `</div></div>`;
    return roomstr;
}

function createDataRowElem(dataElem) {
    let dataRow = "";

    if (dataElem) {

        if (dataElem.id) {

            const user = getAttr("user");

            dataRow += `<div class="room-item" `
            if (user.admin == 1) {
                dataRow += `id="dataE_${dataElem.id}" data-id="${dataElem.id}"`;
            }
            dataRow += `><div class="room-item-header "><span>${escapeHtml(dataElem.anzahl)}x ${escapeHtml(dataElem.name)}</span>`;

            if (user.admin == 1) {
                dataRow += `<div><i class="edit-entry"></i><i class="remove-entry"></i></div>`;
            }
            dataRow += `</div><div class="room-item-body ">`;
            if (dataElem.raumdetail) {
                dataRow += `<span class="room-body-header raumdetail"><strong>${escapeHtml(dataElem.raumdetail)}</strong></span>`;
            }

            if (dataElem.bild1 || dataElem.bild2) {
                dataRow += `<div class="room-body-imgs">`;
                if (dataElem.bild1) {
                    dataRow += `<img class="room-img" src="/data/img/${user.oid}/${dataElem.dgid}/thumbnail/${escapeHtml(dataElem.bild1)}">`;
                }
                if (dataElem.bild2) {
                    dataRow += `<img class="room-img" src="/data/img/${user.oid}/${dataElem.dgid}/thumbnail/${escapeHtml(dataElem.bild2)}">`;
                }
                dataRow += `</div>`;
            }

            if (dataElem.kommentar) {
                dataRow += `<span class="raumkommentar">${escapeHtml(dataElem.kommentar)}</span>`;
            }

            if (user.admin == 1) {

                dataRow += createDetailTableAdmin(dataElem.details);

                // add add Details Row
                dataRow += `<hr/>` +
                    `<div class="room-SN">` +
                    `<div class="room-addSN">Details hinzufügen <i class="add-detail" data-data-id="${dataElem.id}"></i>` +
                    `</div></div>`;
            }

            dataRow += "</div></div>";
        }
    }
    return dataRow;
}

function createDetailRowElem(detailElem, fieldSet) {
    return `<div class="rTable-row">` + // row
        `<div class="rTable-cell"><i class="edit-detail" data-detail-id=${escapeHtml(detailElem.id)} data-data-id="${escapeHtml(detailElem.dataid)}"></i></div>` +
        ((fieldSet["serialnumber"]) ? `<div class="rTable-cell">${escapeHtml(detailElem.serialnumber)}</div>` : "") +
        ((fieldSet["nextcheck"]) ? `<div class="rTable-cell">${escapeHtml(detailElem.nextcheck)}</div>` : "") +
        ((fieldSet["lastcheck"]) ? `<div class="rTable-cell">${escapeHtml(detailElem.lastcheck)}</div>` : "") +
        ((fieldSet["anschaffung"]) ? `<div class="rTable-cell">${escapeHtml(detailElem.anschaffung)}</div>` : "") +
        ((fieldSet["auszuscheiden"]) ? `<div class="rTable-cell">${escapeHtml(detailElem.auszuscheiden)}</div>` : "") +
        ((fieldSet["kommentar"]) ? `<div class="rTable-cell">${escapeHtml(detailElem.kommentar)}</div>` : "") +
        `</div>`; // end row
}

function createDetailTableAdmin(details) {

    const numDetails = (details) ? details.length : 0;
    let detailStr = "";

    if (numDetails > 0) {

        detailStr += `<hr/>` +
            `<div class="room-SN-elems">` +
            `<div class="rTable">` // table
            +
            `<div class="rTable-body">`
        // header

        let fieldSet = {};
        (details).forEach(function (detailElem) {
            if (detailElem.serialnumber) {
                fieldSet["serialnumber"] = true;
            }
            if (detailElem.nextcheck) {
                fieldSet["nextcheck"] = true;
            }
            if (detailElem.lastcheck) {
                fieldSet["lastcheck"] = true;
            }
            if (detailElem.anschaffung) {
                fieldSet["anschaffung"] = true;
            }
            if (detailElem.auszuscheiden) {
                fieldSet["auszuscheiden"] = true;
            }
            if (detailElem.kommentar) {
                fieldSet["kommentar"] = true;
            }
        });

        detailStr += `<div class="rTable-row">` + // header row
            `<div class="rTable-cell"></div>` + // edit field
            ((fieldSet["serialnumber"]) ? `<div class="rTable-cell">Seriennummer</div>` : "") +
            ((fieldSet["nextcheck"]) ? `<div class="rTable-cell">nächste Prüfung</div>` : "") +
            ((fieldSet["lastcheck"]) ? `<div class="rTable-cell">letzte Prüfung</div>` : "") +
            ((fieldSet["anschaffung"]) ? `<div class="rTable-cell">Anschaffung</div>` : "") +
            ((fieldSet["auszuscheiden"]) ? `<div class="rTable-cell">Ausscheiden</div>` : "") +
            ((fieldSet["kommentar"]) ? `<div class="rTable-cell">Kommentar</div>` : "") +
            `</div>`; // end header row

        (details).forEach(function (detailElem) {
            detailStr += createDetailRowElem(detailElem, fieldSet);
        });

        detailStr += `</div></div>` // div-table
            +
            `</div>`; //   room-SN-elems
    }
    return detailStr;
}

export {
    createRoom,
    createDetailTableAdmin,
    createDetailRowElem,
    createDataRowElem
}